// src/components/auth/DashboardRedirect.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const DashboardRedirect = () => {
  const { user, isAuthenticated, loading } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">Redirecting to your dashboard...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Redirect based on user role
  const roleRoutes = {
    patient: '/patient',
    doctor: '/doctor',
    hospital: '/hospital',
    pharmacy: '/pharmacy', 
    driver: '/driver',
    admin: '/admin',
    superadmin: '/admin',
  };

  const redirectPath = roleRoutes[user.role] || '/patient';
  
  return <Navigate to={redirectPath} replace />;
};

export default DashboardRedirect;